import { render, staticRenderFns } from "./UnregisteredLocations.vue?vue&type=template&id=3a3a8a16&"
import script from "./UnregisteredLocations.vue?vue&type=script&lang=js&"
export * from "./UnregisteredLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports